import { AlertTriangle, CheckCircle2, Clock, PackageCheck, Send, Sparkles, Wrench } from 'lucide-react'

export const ITEM_STATUSES = [
  'Available',
  'InUse',
  'Maintenance',
  'Missing',
  'Retired',
  'PendingTransfer',
  'Cleaning',
] as const

export type ItemStatus = (typeof ITEM_STATUSES)[number]

export const itemStatusConfig: Record<ItemStatus, { color: string; bgColor: string; icon: any }> = {
  Available: { color: 'text-success', bgColor: 'bg-success/15', icon: CheckCircle2 },
  InUse: { color: 'text-info', bgColor: 'bg-info/15', icon: Clock },
  Maintenance: { color: 'text-warning', bgColor: 'bg-warning/15', icon: Wrench },
  Missing: { color: 'text-destructive', bgColor: 'bg-destructive/15', icon: AlertTriangle },
  Retired: { color: 'text-slate-500', bgColor: 'bg-slate-500/15', icon: PackageCheck },
  PendingTransfer: { color: 'text-primary', bgColor: 'bg-primary/15', icon: Send },
  Cleaning: { color: 'text-cyan-500', bgColor: 'bg-cyan-500/15', icon: Sparkles },
}
